<template>
    <div class="event-card-info">
        <div
            v-for="(events, id) in relatedEvents"
            :key="id"
            @click="goToEvent(events)"
            class="event-card-profile-wrapper"
        >
            <img class="event-img" :src="eventImage(events)" />
            <div class="event-info">
                <div class="event-header">
                    <div v-if="events.start_date" class="event-date">
                        {{ events.start_date }}
                    </div>
                    <div v-if="width < 600" class="event-title">
                        {{ events.event_name }}
                    </div>
                    <div class="date-time">
                        <div v-if="events.start_time" class="add-info">
                            {{ events.start_time }}
                        </div>
                        <div v-if="events.cover_cost" class="add-info">
                            ${{ events.cover_cost }} Cover
                        </div>
                        <div v-if="events.ages" class="add-info">{{ events.ages }}</div>
                    </div>
                </div>
                <div v-if="width > 600" class="event-title">
                    {{ events.event_name }}
                </div>
                <div class="tags">
                    <div class="vibe">
                        Vibe:
                        <div
                            class="tag-event"
                            v-for="tag in events.keywords.split(',')"
                            :key="tag"
                        >
                            {{ tag }}
                        </div>
                    </div>
                </div>
                <div class="event-artists" v-if="events.responded_artist.length">
                    <div class="featuring">Featuring:</div>
                    <div
                        class="related-artist-info"
                        v-for="(artist, index) in events.responded_artist"
                        :key="index"
                    >
                        <img
                            class="artist-image"
                            :src="artist.artist.artist_info.main_avatar"
                        />
                        <div
                            @click="goToArtistProfile(artist.artist.artist_info.slug)"
                            class="artist-name"
                        >
                            {{ artist.artist.artist_info.band_name }}
                        </div>
                    </div>
                </div>
                <!--@TODO: after discuss with Dastan, I hid buttons, because we don't have functionality-->
                <div class="btn-container d-none">
                    <div class="button-calendar">
                        <div class="call-to-calendar">Add to Calendar</div>
                    </div>
                    <div class="button-share">
                        <div class="call-to-share">Share</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import checkScreen from '../../../../../mixins/check-screen'

    const URLS = {
        images: {
            defaultEventImage: '/images/default-artist-event.png'
        },
        redirect: {
            eventPage: '/event/show'
        }
    }

    export default {
        name: 'EventCard',
        mixins: [checkScreen],
        props: {
            relatedEvents: {
                type: Array,
                default: () => []
            }
        },
        methods: {
            getIcon() {
                return '/images/'
            },
            goToArtistProfile(slug) {
                if (slug) window.location.href = '/artists/' + slug
            },
            goToEvent(event) {
                window.open(`${this.URLS.redirect.eventPage}/${event.id}`, '_blank')
            }
        },
        computed: {
            URLS: () => URLS,
            eventImage: () => (event) => {
                if (event.image) {
                    return event.image
                } else if (
                    event.venue.venue_info.main_avatar.includes('/global/default.png')
                ) {
                    return URLS.images.defaultEventImage
                } else {
                    return event.venue.venue_info.main_avatar
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../../sass/_variables.scss';
    .artist-image {
        border-radius: 50%;
        min-height: 24px;
        max-width: 24px;
        object-fit: cover;
    }
    .event-header {
        display: flex;
        gap: 20px;
    }
    .event-card-info {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
    }
    .event-card-profile-wrapper,
    .event-card-profile-wrapper * {
        box-sizing: border-box;
    }
    .event-card-profile-wrapper {
        border-radius: 16px;
        display: flex;
        flex-direction: row;
        gap: 0;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        overflow: hidden;
        width: 60%;
        cursor: pointer;
    }
    .event-img {
        align-self: stretch;
        flex-shrink: 0;
        max-width: 193px;
        width: 100%;
        position: relative;
        object-fit: cover;
    }
    .event-info {
        background: #262626;
        padding: 16px 20px 20px 20px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: flex-start;
        justify-content: flex-start;
        width: 100%;
        min-height: 200px;
    }
    .date-time {
        display: flex;
        flex-direction: row;
        gap: 20px;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        align-items: flex-end;
    }
    .event-date {
        color: #acacac;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 26px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
    }
    .add-info {
        color: #acacac;
        text-align: left;
        font: 700 14px/130% 'InstrumentSans-Bold', sans-serif;
        padding-bottom: 2px;
    }
    .event-title {
        color: #acacac;
        text-align: left;
        font: 700 20px/120% 'InstrumentSans-Bold', sans-serif;
        position: relative;
        align-self: stretch;
    }
    .tags {
        padding: 4px 0px 10px 0px;
        display: flex;
        flex-direction: row;
        gap: 2px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .vibe {
        color: #acacac;
        text-align: left;
        font: 700 14px/130% 'InstrumentSans-Bold', sans-serif;
        display: flex;
        gap: 5px;
        flex-wrap: wrap;
    }
    .tag-event {
        color: #acacac;
        text-align: left;
        font: 700 14px/130% 'InstrumentSans-Bold', sans-serif;
        overflow-x: hidden;
    }
    .event-artists {
        padding: 0 0 10px 0;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        overflow-y: scroll;
    }
    .event-artists::-webkit-scrollbar {
        width: 0;
    }
    .featuring {
        color: #acacac;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
    }
    .related-artist-info {
        display: flex;
        align-items: center;
        border-radius: 100px;
        padding: 5px 12px 5px 5px;
        gap: 10px;
        background: #262626;
        border: 1px solid #acacac;
    }
    .artist-name {
        color: #acacac;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
        margin: 0;
        cursor: pointer;
    }
    .btn-container {
        border-style: solid;
        border-color: #464646;
        border-width: 1px 0 0 0;
        padding: 20px 0 0 0;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .button-calendar {
        background: #ba87ff;
        border-radius: 100px;
        padding: 7px 30px 9px 30px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
    }
    .call-to-calendar {
        color: #000000;
        text-align: left;
        font: 700 16px/125% 'InstrumentSans-Bold', sans-serif;
        cursor: pointer;
    }
    .button-share {
        background: #262626;
        border-radius: 100px;
        border-style: solid;
        border-color: #ba87ff;
        border-width: 1px;
        padding: 7px 30px 9px 30px;
        display: flex;
        flex-direction: row;
        gap: 0;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 161px;
    }
    .call-to-share {
        color: #ba87ff;
        text-align: left;
        font: 700 16px/125% 'InstrumentSans-Bold', sans-serif;
        cursor: pointer;
    }
    @media (max-width: 600px) {
        .event-card-profile-wrapper {
            min-width: 330px;
            flex-direction: column;
        }
        .event-card-info {
            flex-direction: row;
            overflow: scroll;
        }
        .event-card-info::-webkit-scrollbar {
            width: 0;
        }
        .event-header {
            flex-direction: column;
            gap: 6px;
        }
        .date-time {
            gap: 18px;
        }
        .event-img {
            max-width: 100%;
            max-height: 250px;
        }
        .btn-container {
            flex-direction: column;
        }
        .button-calendar {
            width: 100%;
        }
        .button-share {
            width: 100%;
        }
    }
</style>
